import {
  AutocompleteRenderInputParams,
  TextField,
  TextFieldProps,
} from '@mui/material';

import { LoaderAdornment, RefetchAdornment } from '../adornments';

interface AutocompleteTextfieldProps extends AutocompleteRenderInputParams {
  isFetching?: boolean;
  fetchingText?: string;
  isError?: boolean;
  placeholderText?: string;
  helperText?: React.ReactNode;
  errorHelperText?: React.ReactNode;
  handleRefetch?: () => void;
  label?: string;
  sx?: TextFieldProps['sx'];
}

const AsyncAutocompleteTextfield = (props: AutocompleteTextfieldProps) => {
  const {
    isFetching,
    isError,
    fetchingText = 'Loading..',
    placeholderText,
    helperText = '',
    errorHelperText = 'There was an error loading this data.',
    handleRefetch = () => {
      void 0;
    },
    ...otherProps
  } = props;
  return (
    <TextField
      {...otherProps}
      error={isError}
      helperText={isError ? errorHelperText : helperText}
      placeholder={isFetching ? fetchingText : placeholderText}
      slotProps={{
        input: {
          ...otherProps.InputProps,
          endAdornment: (
            <>
              <RefetchAdornment isError={isError} onClick={handleRefetch} />
              <LoaderAdornment isLoading={isFetching} />
              {otherProps.InputProps.endAdornment}
            </>
          ),
        },
      }}
    />
  );
};

export default AsyncAutocompleteTextfield;
